import { getOrderIdFromUrl } from './getOrderIdFromUrl';

/**
 * Extracts order ID from the current browser window location.
 *
 * This function reads the order ID from either the URL query parameters or hash.
 * It's a client-side only helper that wraps `getOrderIdFromUrl` with browser-specific
 * window.location access.
 */
export function getOrderIdFromWindowLocation(): string | null {
  if (typeof window === 'undefined') return null;

  const searchParams = new URLSearchParams(window.location.search);

  return getOrderIdFromUrl(searchParams, window.location.hash);
}
